import { createAsyncThunk } from '@reduxjs/toolkit'
import { APIError, authenticatedRequest, getExceptionPayload } from '../axiosConfiguration'
import { MetalQuotationFilters, MetalQuotationResponse } from '../type/metalQuotation'
import * as layoutActions from './layout'

export const getMetalQuotation = createAsyncThunk<MetalQuotationResponse, MetalQuotationFilters, { rejectValue: APIError }>(
  'metalQuotation/getMetalQuotation',
  async (filters, { dispatch, rejectWithValue }) => {
    dispatch(layoutActions.startLoading())

    const URLParameters = new URLSearchParams()
    URLParameters.append('metal', filters.metal)
    URLParameters.append('priceList', filters.priceList)
    URLParameters.append('currency', filters.currency)
    URLParameters.append('reqType', filters.reqType)
    URLParameters.append('dateFrom', filters.dateFrom)
    URLParameters.append('dateTo', filters.dateTo)

    try {
      const instance = await authenticatedRequest()
      const res = await instance.get<MetalQuotationResponse>('metalquotation', {
        params: URLParameters,
      })

      dispatch(layoutActions.endLoading())
      return res.data
    } catch (error) {
      const err = getExceptionPayload(error, 'homepage:error.getMetalQuotation')

      dispatch(layoutActions.endLoading())
      dispatch(layoutActions.showToast({ summary: err.message, severity: 'error' }))

      return rejectWithValue(err)
    }
  },
)
